import { navigate, NavigateFn } from '@reach/router'
import { BASE_PATH } from '../constants/url'

const goto: NavigateFn = async(...args: any[])=>{
  const url = args[0]
  const options = args[1]

  const urlIsString = typeof url === 'string'

  return await navigate(urlIsString ? BASE_PATH + url : url, options)
}

export default goto
